export default (initialState: any) => {
  // 在这里按照初始化数据定义项目中的权限，统一管理
  // const isLogin = !!(initialState?._csrf?.token && initialState?.userId);

  // 按钮权限相关,是否有权限展示这个按钮
  const isShowAccessButton = initialState?.roleType !== 4;

  // 当前是 admin 还是普通 user
  const currentUserType = localStorage.getItem('currentUserType') || 'user';

  // 获取产品或者项目标识
  const project = process?.env?.project;

  return {
    // isLogin,
    isShowAccessButton,
    currentUserType,
    project,
  };
};
